import cx from "classnames";
import React from "react";

import styles from "./TrimContent.mscss";

interface OwnProps {
    className?: string;
    expandLabel: React.ReactNode;
    collapseLabel?: React.ReactNode;
    height: number;
    maskGradient?: string;
}

interface State {
    autoExpanded: boolean;
    expanded: boolean;
}

type Props = OwnProps;

export class TrimContent extends React.Component<Props, State> {
    public static defaultProps: Pick<OwnProps, "maskGradient"> = {
        maskGradient:
            "linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0))",
    };

    public state: State = {
        expanded: false,
        autoExpanded: false,
    };

    private content: HTMLDivElement;

    public componentDidMount() {
        if (this.content) {
            const computed = window.getComputedStyle(this.content);
            if (parseFloat(computed.height) < this.props.height) {
                this.setState({ autoExpanded: true, expanded: true });
            }
        }
    }

    public render() {
        const { className, children, expandLabel, height, maskGradient, collapseLabel } =
            this.props;
        const { expanded, autoExpanded } = this.state;

        const maskStyles = {
            backgroundImage: maskGradient,
        };

        return (
            <>
                <div
                    className={cx(
                        styles.TrimContent__content,
                        className,
                        expanded && styles["TrimContent__content--expaned"],
                    )}
                    style={{ maxHeight: expanded ? undefined : height }}
                    ref={(r) => (this.content = r)}
                >
                    {children}
                    {!expanded && (
                        <div className={cx(styles.TrimContent__content__mask)} style={maskStyles} />
                    )}
                </div>
                {!expanded && (
                    <div className={cx(styles.TrimContent__label)} onClick={this.onExpand}>
                        {expandLabel}
                    </div>
                )}
                {!autoExpanded && expanded && collapseLabel && (
                    <div className={cx(styles.TrimContent__label)} onClick={this.onCollapse}>
                        {collapseLabel}
                    </div>
                )}
            </>
        );
    }

    private onExpand = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        this.setState({ expanded: true });
    };

    private onCollapse = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        this.setState({ expanded: false });
    };
}
